import DialogContent from './DialogContent'

export default DialogContent
